// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import __setDefaultSdkOptions from "../sdk-helpers/__setDefaultSdkOptions";

import createAppAttestChallengeIssue from "./appAttest/postAppAttestChallengeIssue";
import createAppAttestKeyRegister from "./appAttest/postAppAttestKeyRegister";
import createEmailCheckDeliverable from "./email/postEmailCheckDeliverable";
import createOauthAppleVerify from "./oauth/postOauthAppleVerify";
import createOauthGoogleVerify from "./oauth/postOauthGoogleVerify";
import createOauthProviderConfigGet from "./oauth/postOauthProviderConfigGet";
import createOtpRedeem from "./otp/postOtpRedeem";
import createOtpRequest from "./otp/postOtpRequest";
import createOtpVerify from "./otp/postOtpVerify";
import createSessionRefresh from "./session/postSessionRefresh";

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

// Every method is built from RESOLVED options, never the raw argument.
// `sdk()` with no arguments has to work. That is the shape every generated
// hook uses through useCallSdk(), and passing the raw `undefined` through
// gave those methods no apiHost and no "/v1/<zone>" prefix, so they POSTed to
// a bare relative "/resource/action".
export default function sdk(options?: SdkOptions) {
  const resolvedOptions = __setDefaultSdkOptions(options);
  return {
    postAppAttestChallengeIssue: createAppAttestChallengeIssue(resolvedOptions),
    postAppAttestKeyRegister: createAppAttestKeyRegister(resolvedOptions),
    postEmailCheckDeliverable: createEmailCheckDeliverable(resolvedOptions),
    postOauthAppleVerify: createOauthAppleVerify(resolvedOptions),
    postOauthGoogleVerify: createOauthGoogleVerify(resolvedOptions),
    postOauthProviderConfigGet: createOauthProviderConfigGet(resolvedOptions),
    postOtpRedeem: createOtpRedeem(resolvedOptions),
    postOtpRequest: createOtpRequest(resolvedOptions),
    postOtpVerify: createOtpVerify(resolvedOptions),
    postSessionRefresh: createSessionRefresh(resolvedOptions),
  };
}
